<i class="fas fa-cog fa-spin fa-3x"></i>
<p class="mt-3 font-weight-bold">...Warten auf Abstimmung...</p>
<p>Warte kurz bis die Versammlungsleitung die elektronische Abstimmung freigibt.</p>
